<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <nav>
        <ul>
          <li>
            <a href="http://openalplab.unito.it"> Openalplab </a>
          </li>
          <li>
            <a v-on:click="goToContattiPage()" style="cursor: pointer">
              Contatti
            </a>
          </li>
          <li>
            <a v-on:click="goToPolicyPrivacyPage()" style="cursor: pointer">
              POLICY PRIVACY
            </a>
          </li>

          <li>
            <a style="cursor: pointer" href="http://www.di.unito.it/do/home.pl"
              >Powered by Dipartimento di Informatica - UniTo
            </a>
          </li>
        </ul>
      </nav>
      <div class="copyright">
        &copy; {{ year }}, Designed by
        <a href="https:///www.invisionapp.com" target="_blank" rel="noopener"
          >Invision</a
        >. Coded by
        <a href="https://binarcode.com" target="_blank" rel="noopener"
          >BinarCode</a
        >
        and
        <a href="https://www.creative-tim.com" target="_blank" rel="noopener"
          >Creative Tim</a
        >.
      </div>
      <!--
      <div class="copyright">
        &copy; {{ year }}, Designed by
        <a href="https:///www.invisionapp.com" target="_blank" rel="noopener"
          >Invision</a
        >.
      </div>
      -->
    </div>
    <cookie-law theme="dark-lime--rounded" buttonText="Ho capito" :storageName="isGeodidalab ? 'geodidalab' : 'istitutomosso'">
      <div slot="message">
        Questo sito utilizza solo i cookie tecnici al fine di migliorare la tua
        esperienza di navigazione.
        <router-link
          to="/policyPrivacy"
          style="color: skyblue; text-decoration: underline"
          >Leggi di più</router-link
        >
      </div>
    </cookie-law>
  </footer>
</template>
<script>
import router from "../router";
/*https://openbase.com/js/vue-cookie-law*/
import CookieLaw from "vue-cookie-law";
import { config } from "../utils/config";

export default {
  components: { CookieLaw },

  props: {
    backgroundColor: String,
    type: String,
  },
  data() {
    return {
      year: new Date().getFullYear(),
      isGeodidalab: true,

    };
  },

  beforeMount(){
    this.isGeodidalab = config.isGeodidalab;
  },

  methods: {
    goToContattiPage() {
      if (router.history.current.name !== "contatti") {
        router.push({ path: "/contatti" });
      }
    },
    goToPolicyPrivacyPage() {
      if (router.history.current.name !== "policyPrivacy") {
        router.push({ path: "/policyPrivacy" });
      }
    },
  },
};
</script>
<style>
</style>
